import './Legal.css';

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-content">
          <h1>Terms and Conditions</h1>
          <p className="last-updated">
            Last Updated: {new Date().toLocaleDateString()}
          </p>

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using the SradhaTech website, services, and communication platforms, you accept and agree to be bound by the terms and provisions of this agreement. These terms govern all user interactions with our digital properties, including your participation in our SMS and email messaging campaigns.
            </p>
          </section>

          <section>
            <h2>2. SMS and Text Communications</h2>
            <p>
              By providing your phone number, you agree to receive a text message from Sradha Tech. Message and Data rates may apply. Message frequency varies. To stop receiving messages, reply STOP at any time. For more information, reply HELP. These messages may include service updates, promotional content, and other notifications.
            </p>
            <ul>
              <li><strong>Message Frequency:</strong> Message frequency varies based on the type of communication.</li>
              <li><strong>Message and Data Rates:</strong> Standard message and data rates may apply as determined by your mobile carrier.</li>
              <li><strong>Opt-Out Instructions:</strong> You can opt out of receiving text messages at any time by replying &apos;STOP&apos;.</li>
              <li><strong>HELP Information:</strong> For assistance, reply &apos;HELP&apos; or contact us at info@sradhatech.com.</li>
              <li><strong>Privacy Policy:</strong> Mobile information will not be shared with third parties for marketing or promotional purposes. For more details, refer to our Privacy Policy.</li>
            </ul>
          </section>

          <section>
            <h2>3. Usage Restrictions & Prohibited Conduct</h2>
            <p>
              Permission is granted to temporarily access the materials on our
              website for personal, non-commercial transitory viewing only. This license shall automatically terminate if you violate any of the following restrictions outlining prohibited conduct:
            </p>
            <ul>
              <li><strong>Unauthorized Modification:</strong> You may not modify, copy, or distribute the materials on this website.</li>
              <li><strong>Commercial Exploitation:</strong> You may not use the materials or our communication services for any commercial purpose without prior written authorization from SradhaTech.</li>
              <li><strong>Abusive Interactions:</strong> You may not engage in harassment, spamming, phishing, or fraudulent interactions via our contact forms, email, or SMS services.</li>
              <li><strong>System Integrity:</strong> You may not attempt to decompile, reverse engineer, or otherwise compromise the security and stability of our website or software infrastructure.</li>
            </ul>
          </section>

          <section>
            <h2>4. Disclaimer</h2>
            <p>
              The materials on our website are provided on an &apos;as is&apos;
              basis. We make no warranties, expressed or implied, and hereby
              disclaim and negate all other warranties including, without
              limitation:
            </p>
            <ul>
              <li>Merchantability</li>
              <li>Fitness for a particular purpose</li>
              <li>Non-infringement of intellectual property</li>
            </ul>
          </section>

          <section>
            <h2>5. Limitations of Liability</h2>
            <p>
              In no event shall Sradha Technologies LLC, its directors, employees, or suppliers be liable for any direct, indirect, incidental, or consequential damages arising out of the use or inability to use the materials on our website or our communication channels. This includes, without limitation, any liability limitations relating to our SMS messaging services, data loss, or business interruption, even if SradhaTech has been notified orally or in writing of the possibility of such damage.
            </p>
          </section>

          <section>
            <h2>6. Revisions</h2>
            <p>
              We may revise these terms and conditions at any time without notice.
              By using this website, you agree to be bound by the current
              version of these terms and conditions.
            </p>
          </section>

          <section>
            <h2>7. Contact Us</h2>
            <p>
              If you have questions about these Terms, please contact us at:{' '}
              <button
                type="button"
                className="email-link"
                onClick={() =>
                  (window.location.href = 'mailto:legal@sradhatech.com')
                }
              >
                legal@sradhatech.com
              </button>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
